import { render, staticRenderFns } from "./ProductsTableProducer.vue?vue&type=template&id=44a4f2ae&"
import script from "./ProductsTableProducer.vue?vue&type=script&lang=js&"
export * from "./ProductsTableProducer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports